import { render, staticRenderFns } from "./InfoTopicContent.vue?vue&type=template&id=acca073e&scoped=true&"
import script from "./InfoTopicContent.vue?vue&type=script&lang=js&"
export * from "./InfoTopicContent.vue?vue&type=script&lang=js&"
import style0 from "./InfoTopicContent.vue?vue&type=style&index=0&id=acca073e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acca073e",
  null
  
)

export default component.exports